import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { ApiService } from '../../root-services/api.service';
import { EditionSettings } from './../../models/global/edition-settings';
import { EditionListService } from '../../editions/edition.service';

@Injectable()
export class EditionService {
  public editionTimeZone: string;

  constructor(private api: ApiService, private editionList: EditionListService) { }

  public getEdition(): Observable<EditionSettings> {
    return this.editionList.getEditionSubject().flatMap(edition =>
      this.api.get('/editions/' + edition.id)
        .map(response => response.json() as EditionSettings)
        .publishReplay(1).refCount()
        .catch(this.handleError)
    );
  }

  public editEdition(body: EditionSettings): Observable<any> {
    let editionId = this.editionList.getEdition().id.toString();
    return this.api.put('/editions/' + editionId, body)
                   .map(() => {})
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public jumpToLearning(path?: string): void {
    // fetches the learning URL for the current edition and redirects
    let url = '/get_learning_url';
    if(path) {
      url += '?path=' + encodeURI(path);
    }
    this.api.get(url)
        .map(response => response.json())
        .subscribe(response => {
      window.location.assign(response.url);
    });
  }

  /**
   * Private Methods
   */
  private handleError(error: any): Promise<any> {
    console.error('An error occured:', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/services/edition.service.ts